(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cinta-anuncios"] && !Shopify.designMode) return;
  try {
    
  class CintaAnuncios extends HTMLElement {
    connectedCallback() {
      this.pista = this.querySelector('.cinta-anuncios__pista');
      this.original = this.pista.firstElementChild;
      if (!this.original || !this.original.textContent.trim()) return;
      this.armar = this.armar.bind(this);
      this.observador = new ResizeObserver(this.armar);
      this.observador.observe(this);
      if (document.fonts) document.fonts.ready.then(this.armar);
    }

    disconnectedCallback() {
      if (this.observador) this.observador.disconnect();
    }

    armar() {
      const anchoVentana = this.clientWidth;
      const anchoGrupo = this.original.getBoundingClientRect().width;
      if (!anchoVentana || !anchoGrupo) return;

      const copiasNecesarias = Math.ceil(anchoVentana / anchoGrupo) + 1;
      while (this.pista.children.length > copiasNecesarias) this.pista.lastElementChild.remove();
      while (this.pista.children.length < copiasNecesarias) {
        const copia = this.original.cloneNode(true);
        copia.setAttribute('aria-hidden', 'true');
        copia.querySelectorAll('[data-shopify-editor-block]').forEach((el) => el.removeAttribute('data-shopify-editor-block'));
        this.pista.append(copia);
      }

      const segundosPorPantalla = parseFloat(getComputedStyle(this).getPropertyValue('--cinta-segundos-por-pantalla')) || 15;
      const pixelesPorSegundo = anchoVentana / segundosPorPantalla;
      this.style.setProperty('--cinta-ancho-grupo', anchoGrupo + 'px');
      this.style.setProperty('--cinta-duracion', anchoGrupo / pixelesPorSegundo + 's');
      this.setAttribute('data-listo', '');
    }
  }

  if (!customElements.get('cinta-anuncios')) customElements.define('cinta-anuncios', CintaAnuncios);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
